module.exports = "<my-title my-label=\"$root.labels.sale.statements.edit\"\n  my-style=\"$root.styles.titles.center\"\n  my-level=\"3\">\n</my-title>\n\n<my-sale-edit-form my-sale=\"$$sale.data.mySale\"\n  my-wagons=\"$$wagon.data.myWagons\">\n</my-sale-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/scrapping/sale/templates/edit.html
// module id = 1622
// module chunks = 0